import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "inscription",
  "data-model-id": "3:4599"
}
const _hoisted_2 = { class: "inscription-container" }
const _hoisted_3 = { class: "inscription-left" }
const _hoisted_4 = { class: "inscription-content" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "logo-section" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    alt: "Florisuite Logo",
    src: "https://c.animaapp.com/nNxA75tB/img/frame-402-1.svg"
  })
], -1)
const _hoisted_6 = { class: "form-section" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "form-header" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "form-title" }, "Créer un compte"),
  /*#__PURE__*/_createElementVNode("p", { class: "form-subtitle" }, "Commencez votre essai gratuit de 14 jours")
], -1)
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"form-row\"><div class=\"form-group\"><label class=\"form-label\" for=\"firstName\">Prénom</label><input class=\"form-input\" type=\"text\" id=\"firstName\" placeholder=\"Votre prénom\" required></div><div class=\"form-group\"><label class=\"form-label\" for=\"lastName\">Nom</label><input class=\"form-input\" type=\"text\" id=\"lastName\" placeholder=\"Votre nom\" required></div></div><div class=\"form-group\"><label class=\"form-label\" for=\"email\">Email</label><input class=\"form-input\" type=\"email\" id=\"email\" placeholder=\"votre.email@exemple.com\" required></div><div class=\"form-group\"><label class=\"form-label\" for=\"shopName\">Nom de la boutique</label><input class=\"form-input\" type=\"text\" id=\"shopName\" placeholder=\"Le nom de votre boutique\" required></div><div class=\"form-group\"><label class=\"form-label\" for=\"password\">Mot de passe</label><input class=\"form-input\" type=\"password\" id=\"password\" placeholder=\"••••••••\" required></div><div class=\"form-group\"><label class=\"form-label\" for=\"confirmPassword\">Confirmer le mot de passe</label><input class=\"form-input\" type=\"password\" id=\"confirmPassword\" placeholder=\"••••••••\" required></div><label class=\"checkbox-label\"><input type=\"checkbox\" class=\"checkbox-input\" required><span> J&#39;accepte les <a href=\"#\" class=\"terms-link\">conditions d&#39;utilisation</a> et la <a href=\"#\" class=\"terms-link\">politique de confidentialité</a></span></label><button class=\"submit-button\" type=\"submit\"><span class=\"button-text\">Créer mon compte</span></button>", 7)
const _hoisted_15 = [
  _hoisted_8
]
const _hoisted_16 = { class: "login-prompt" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "prompt-text" }, "Vous avez déjà un compte ?", -1)
const _hoisted_18 = { class: "inscription-right" }
const _hoisted_19 = { class: "hero-content" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h2", { class: "hero-title" }, "Rejoignez des centaines de fleuristes", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "hero-description" }, " Simplifiez la gestion de votre boutique et développez votre activité avec Florisuite. ", -1)
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/_createStaticVNode("<div class=\"features-list\"><div class=\"feature-item\"><img class=\"check-icon\" alt=\"Check\" src=\"https://c.animaapp.com/nNxA75tB/img/circle-check-big-7.svg\"><span>14 jours d&#39;essai gratuit</span></div><div class=\"feature-item\"><img class=\"check-icon\" alt=\"Check\" src=\"https://c.animaapp.com/nNxA75tB/img/circle-check-big-7.svg\"><span>Aucune carte bancaire requise</span></div><div class=\"feature-item\"><img class=\"check-icon\" alt=\"Check\" src=\"https://c.animaapp.com/nNxA75tB/img/circle-check-big-7.svg\"><span>Support dédié inclus</span></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("form", {
              class: "signup-form",
              onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSignup && _ctx.handleSignup(...args)), ["prevent"]))
            }, _hoisted_15, 32),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createVNode(_component_RouterLink, {
                to: "/connexion",
                class: "login-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Se connecter ")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _hoisted_21,
          _createElementVNode("img", {
            class: "hero-image",
            alt: "Aperçu Florisuite",
            src: `${_ctx.publicBase}assets/fonctionnalites/essai.webp`
          }, null, 8, _hoisted_22),
          _hoisted_23
        ])
      ])
    ])
  ]))
}